"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var classNames = require('classnames');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var Button = require('../button');

var _require = require('./constants'),
    dataHooks = _require.dataHooks;

var BaseModalFooter = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BaseModalFooter, _React$PureComponent);

  var _super = _createSuper(BaseModalFooter);

  function BaseModalFooter() {
    _classCallCheck(this, BaseModalFooter);

    return _super.apply(this, arguments);
  }

  _createClass(BaseModalFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          sideActions = _this$props.sideActions,
          primaryButtonText = _this$props.primaryButtonText,
          primaryButtonOnClick = _this$props.primaryButtonOnClick,
          primaryButtonProps = _this$props.primaryButtonProps,
          secondaryButtonText = _this$props.secondaryButtonText,
          secondaryButtonOnClick = _this$props.secondaryButtonOnClick,
          secondaryButtonProps = _this$props.secondaryButtonProps;

      if (!sideActions && !secondaryButtonText && !primaryButtonText) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classNames('control-base-modal-footer', className)
      }, sideActions && /*#__PURE__*/React.createElement("div", {
        className: "control-base-modal-side-actions",
        "data-hook": dataHooks.sideActions
      }, sideActions), secondaryButtonText && /*#__PURE__*/React.createElement(Button, _extends({
        className: "control-base-modal-btn btn-confirm-secondary btn-md",
        onClick: secondaryButtonOnClick,
        dataHook: dataHooks.secondaryButton
      }, secondaryButtonProps), secondaryButtonText), primaryButtonText && /*#__PURE__*/React.createElement(Button, _extends({
        className: "control-base-modal-btn btn-confirm-primary btn-md",
        onClick: primaryButtonOnClick,
        dataHook: dataHooks.primaryButton
      }, primaryButtonProps), primaryButtonText));
    }
  }]);

  return BaseModalFooter;
}(React.PureComponent);

BaseModalFooter.displayName = displayNames.BASE_MODAL_FOOTER;
BaseModalFooter.propTypes = {
  /** A css class to be applied to the component's root element */
  className: PropTypes.string,

  /** side actions node, to be rendered as the first element on the same row as the action buttons */
  sideActions: PropTypes.node,

  /** a text for the primary action button */
  primaryButtonText: PropTypes.string,

  /** Passed to the primary action button as props without any filter / mutation */
  primaryButtonProps: PropTypes.object,

  /** callback for when the secondary action button is clicked */
  primaryButtonOnClick: PropTypes.func,

  /** a text for the secondary action button */
  secondaryButtonText: PropTypes.string,

  /** Passed to the secondary button as props without any filter / mutation */
  secondaryButtonProps: PropTypes.object,

  /** callback for when the secondary action button is clicked */
  secondaryButtonOnClick: PropTypes.func
};
BaseModalFooter.defaultProps = {};
module.exports = compose(BaseModalFooter);